module.exports = __webpack_public_path__ + "71242dca1127c2bc76e54dc13af96ccf.png";